import React from "react";

function BetaStageIcon() {
  return (
    <svg width="45" height="18" viewBox="0 0 45 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.936 13H12.584C14.048 13 14.9 12.124 14.9 10.84C14.9 9.88 14.192 9.004 13.34 8.872C14.072 8.716 14.744 8.044 14.744 7.036C14.744 5.836 13.892 4.996 12.5 4.996H8.936V13ZM9.932 8.464V5.884H12.332C13.232 5.884 13.712 6.46 13.712 7.18C13.712 7.912 13.232 8.464 12.332 8.464H9.932ZM9.932 12.112V9.352H12.38C13.364 9.352 13.868 10 13.868 10.732C13.868 11.584 13.316 12.112 12.38 12.112H9.932ZM16.8829 13H22.1269V12.112H17.8789V9.352H22.0429V8.464H17.8789V5.884H22.1269V4.996H16.8829V13ZM26.0949 13H27.0909V5.884H29.6349V4.996H23.5629V5.884H26.0949V13ZM36.2981 13H37.4021L34.1741 4.996H32.9381L29.7221 13H30.8261L31.5341 11.224H35.5901L36.2981 13ZM33.5621 5.884L35.2901 10.336H31.8221L33.5621 5.884Z"
        fill="#E3000F"
      />
      <rect x="0.5" y="0.5" width="44" height="17" rx="3.5" stroke="#E3000F" />
    </svg>
  );
}

export default BetaStageIcon;
